// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XuV47y {
  max-width: 480px;
  width: 100%;
}

.CA4n5w {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4, 32px);
  text-align: left;
  animation: SGq7Qi 0.3s ease-out 0.1s both;
  position: relative;
}

.OHwhXZ {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.trycVF {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-lg, 20px);
  line-height: 1.4;
  color: var(--text-neutral-dark, #333333);
  margin: 0;
  flex: 1;
}

.EmUnld {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: var(--spacing-2, 16px);
}

.EmUnld:hover {
  opacity: 0.8;
}

.TEGAO5 {
  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);
  font-weight: var(--font-weight-regular, 400);
  font-size: var(--font-size-md, 16px);
  line-height: 1.5;
  color: var(--text-neutral-dark, #333333);
  margin: 0;
}

.nLF6HT {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-2, 16px);
  width: 100%;
}

.AL6k6Y {
  flex: 1;
}

.RaomY5 {
  flex: 1;
}

@media (max-width: 768px) {
  .XuV47y {
    max-width: 90vw;
    margin: var(--spacing-2, 16px);
  }

  .CA4n5w {
    gap: var(--spacing-3, 24px);
  }

  .trycVF {
    font-size: var(--font-size-md, 18px);
  }

  .TEGAO5 {
    font-size: var(--font-size-sm, 14px);
  }

  .nLF6HT {
    flex-direction: column;
  }

  .AL6k6Y,
  .RaomY5 {
    width: 100%;
  }
}

@keyframes SGq7Qi {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/PixKeyDeleteModal/PixKeyDeleteModal.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,yCAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iEAAiE;EACjE,6CAA6C;EAC7C,oCAAoC;EACpC,gBAAgB;EAChB,wCAAwC;EACxC,SAAS;EACT,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iEAAiE;EACjE,4CAA4C;EAC5C,oCAAoC;EACpC,gBAAgB;EAChB,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;EACE;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".modal {\n  max-width: 480px;\n  width: 100%;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-4, 32px);\n  text-align: left;\n  animation: contentFadeIn 0.3s ease-out 0.1s both;\n  position: relative;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.title {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--font-size-lg, 20px);\n  line-height: 1.4;\n  color: var(--text-neutral-dark, #333333);\n  margin: 0;\n  flex: 1;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: var(--spacing-2, 16px);\n}\n\n.closeButton:hover {\n  opacity: 0.8;\n}\n\n.description {\n  font-family: var(--font-family-base, 'Source Sans 3', sans-serif);\n  font-weight: var(--font-weight-regular, 400);\n  font-size: var(--font-size-md, 16px);\n  line-height: 1.5;\n  color: var(--text-neutral-dark, #333333);\n  margin: 0;\n}\n\n.actions {\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-2, 16px);\n  width: 100%;\n}\n\n.cancelButton {\n  flex: 1;\n}\n\n.confirmButton {\n  flex: 1;\n}\n\n@media (max-width: 768px) {\n  .modal {\n    max-width: 90vw;\n    margin: var(--spacing-2, 16px);\n  }\n\n  .content {\n    gap: var(--spacing-3, 24px);\n  }\n\n  .title {\n    font-size: var(--font-size-md, 18px);\n  }\n\n  .description {\n    font-size: var(--font-size-sm, 14px);\n  }\n\n  .actions {\n    flex-direction: column;\n  }\n\n  .cancelButton,\n  .confirmButton {\n    width: 100%;\n  }\n}\n\n@keyframes contentFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `XuV47y`,
	"content": `CA4n5w`,
	"contentFadeIn": `SGq7Qi`,
	"header": `OHwhXZ`,
	"title": `trycVF`,
	"closeButton": `EmUnld`,
	"description": `TEGAO5`,
	"actions": `nLF6HT`,
	"cancelButton": `AL6k6Y`,
	"confirmButton": `RaomY5`
};
module.exports = ___CSS_LOADER_EXPORT___;
